import * as yup from 'yup';
import { onlyEnglishAndHebrewAndSpace, onlyNumbersRegExp } from '../../../helpers/regExps';
import { ONLY_DIGIT_PERMITED_PATH, ONLY_LETTERS_HEBREW_OR_ENGLISH_PERMITED_PATH, REQUIRED_FIELD_PATH } from '../../errorMessages';


export const yupObjectAdditionalContactDetailsNotRequired = {
    mailCity: yup.string()
        .notRequired(),
    mailStreet: yup.string()
        .notRequired(),
    mailHouse: yup.string()
        .notRequired(),
    mailAppartment: yup.string()
        .notRequired(),
    mailMikod: yup.string()
        .notRequired(),
}

export const yupObjectAdditionalContactDetailsRequired = {
    mailCity: yup.string()
        .matches(onlyEnglishAndHebrewAndSpace, ONLY_LETTERS_HEBREW_OR_ENGLISH_PERMITED_PATH)
        .required(REQUIRED_FIELD_PATH),
    mailStreet: yup.string()
        .matches(onlyEnglishAndHebrewAndSpace, ONLY_LETTERS_HEBREW_OR_ENGLISH_PERMITED_PATH)
        .required(REQUIRED_FIELD_PATH),
    mailHouse: yup.string()
        .matches(onlyNumbersRegExp, ONLY_DIGIT_PERMITED_PATH)
        .required(REQUIRED_FIELD_PATH),
    mailAppartment: yup.string()
        .matches(onlyNumbersRegExp, ONLY_DIGIT_PERMITED_PATH)
        .required(REQUIRED_FIELD_PATH),
    mailMikod: yup.string()
        .matches(/^[0-9]+$/, ONLY_DIGIT_PERMITED_PATH)
        .required(REQUIRED_FIELD_PATH),
}